import React from 'react';
import type { PushCampaignStatus } from '../../services/resortAdminApi';

const STATUS_BADGE: Record<PushCampaignStatus, string> = {
  Draft: 'bg-gray-100 text-gray-700',
  Scheduled: 'bg-blue-100 text-blue-800',
  Sending: 'bg-amber-100 text-amber-800',
  Stopping: 'bg-orange-100 text-orange-800',
  Paused: 'bg-yellow-100 text-yellow-800',
  Sent: 'bg-green-100 text-green-800',
  Cancelled: 'bg-gray-100 text-gray-600',
  Failed: 'bg-red-100 text-red-800',
};

interface PushCampaignStatusBadgeProps {
  status: PushCampaignStatus;
}

export const PushCampaignStatusBadge: React.FC<PushCampaignStatusBadgeProps> = props => {
  const style = STATUS_BADGE[props.status] || 'bg-gray-100 text-gray-600';
  return (
    <span className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${style}`}>
      {props.status}
    </span>
  );
};
